import { render, staticRenderFns } from "./ClientsFilter.vue?vue&type=template&id=dfc770c2&scoped=true"
import script from "./ClientsFilter.vue?vue&type=script&lang=js"
export * from "./ClientsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc770c2",
  null
  
)

export default component.exports